import axios from 'axios';

import {
  getV2RootUrl,
  axiosHeaderV2,
  publicAxiosHeaderV2
} from 'common/helpers/apiHelper';

export const listReservations = (customerId, queryString) => {
  if (queryString) {
    return axios.get(
      `${getV2RootUrl()}/customer/${customerId}/reservation?${queryString}`,
      axiosHeaderV2()
    );
  }
  return axios.get(
    `${getV2RootUrl()}/customer/${customerId}/reservation`,
    axiosHeaderV2()
  );
};

export const getReservation = (reservationId) =>
  axios.get(
    `${getV2RootUrl()}/reservation/${reservationId}/limited`,
    publicAxiosHeaderV2()
  );

export const cancelReservation = (customerId, reservationId) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId}/reservation/${reservationId}/cancel`,
    {},
    axiosHeaderV2()
  );
